import angular from 'angular';
import adminpulse from '@/shared/utils/adminpulse';
import guid from '@/shared/utils/guid';
import DocumentService from '@/shared/services/DocumentService';
import dataCacheService from '@/shared/services/DataCacheService';
import AuthService from '@/shared/services/AuthService';

angular
  .module('cloudX')
  .controller('AmlSingleDocumentDialogCtrl', [
    'flySvc',
    '$element',
    'close',
    'relation',
    'appUrls',
    '$http',
    '$timeout',
    '$filter',
    'translateListFilter',
    'templateType',
    '$translate',
    AmlSingleDocumentDialogCtrl,
  ]);

function AmlSingleDocumentDialogCtrl(
  flySvc,
  $element,
  close,
  relation,
  appUrls,
  $http,
  $timeout,
  $filter,
  translateListFilter,
  templateType,
  $translate,
) {
  var vm = this;
  vm.data = {
    relationId: relation.id,
    templateId: null,
    templateType,
    tags: {},
    addQrCode: false,
  };
  vm.hasCustomTags = false;
  vm.loadingPreview = false;
  vm.loadingTags = false;
  vm.saving = false;
  vm.preview = null;
  vm.templates = null;
  vm.templateTags = [];
  vm.hasQrCodeTag = false;
  vm.hasOffice365Platform = dataCacheService.hasUserConnectPlatform(46);

  var showError = function(error) {
    flySvc.error(error.data.code, error.data.parameters);
  };
  var showArrayBufferError = function(error) {
    if (!error) return;
    try {
      var buffer = error.data || error;
      const errorObject = adminpulse.arrayBufferToObject(buffer) || {};
      flySvc.error(errorObject);
    } catch (ex) {
      //Parsing error?
      flySvc.error();
    }
  };

  vm.generateAndEditDocuments = function(dl) {
    if (vm.saving) return;
    vm.saving = true;
    const model = vm.getGenerateModel();
    $http.post(`${appUrls.api}/Api/Relation/AmlSingleDocument/`, model).then(
      ({ data }) => {
        if (data) {
          const language = $translate.use().split('-')[0];
          DocumentService.edit(data.id, language).finally(() => {
            $timeout(function() {
              vm.saving = false;
              close(data, 500);
              $element.modal('hide');
            }, 0);
          });
        } else {
          vm.saving = false;
        }
      },
      error => {
        vm.saving = false;
        showError(error);
      },
    );
  };

  vm.generateDocuments = function(dl) {
    if (vm.saving) return;
    vm.saving = true;
    const model = vm.getGenerateModel();
    $http
      .post(`${appUrls.api}/Api/Relation/AmlSingleDocument/`, model)
      .then(({ data }) => {
        if (data) {
          const language = $translate.use().split('-')[0];
          close(data, 500);
        }
      })
      .catch(error => {
        showError(error);
      })
      .finally(() => {
        vm.saving = false;
        $element.modal('hide');
      });
  };

  vm.generateAndCheckoutDocuments = function(openInApp) {
    if (vm.saving) return;
    vm.saving = true;
    const model = vm.getGenerateModel();
    $http.post(`${appUrls.api}/Api/Relation/AmlSingleDocument/`, model).then(
      ({ data }) => {
        if (data) {
          vm.checkoutDocument(data, openInApp);
        } else {
          vm.saving = false;
        }
      },
      error => {
        vm.saving = false;
        showError(error);
      },
    );
  };

  vm.checkoutDocument = function(document, openInApp) {
    if (!document || !document.canEdit) return;
    DocumentService.checkout(document.id, openInApp).then(
      data => {
        if (!!data) {
          document.checkedOutByUserId = AuthService.getUserId();
          flySvc.success();
        }
        $timeout(function() {
          vm.saving = false;
          close(document, 500);
          $element.modal('hide');
        }, 0);
      },
      error => {
        console.error(error);
        if (error.response && error.response.data && error.response.data.code) {
          flySvc.error(error);
        } else {
          flySvc.success();
        }
        $timeout(function() {
          vm.saving = false;
          close(null, 500);
          $element.modal('hide');
        }, 0);
        log.error('error checking out document ', error);
      },
    );
  };

  vm.generatePreview = function() {
    vm.loadingPreview = true;
    vm.preview = null;
    const model = vm.getGenerateModel();
    $http
      .post(`${appUrls.api}/Api/Relation/AMLSinglePreview/`, model, {
        responseType: 'arraybuffer',
      })
      .then(
        response => {
          vm.loadingPreview = false;
          if (!response || !response.data) return;
          var blob = new Blob([response.data], { type: 'image/png' });
          var reader = new FileReader();
          reader.onload = function(evt) {
            $timeout(function() {
              vm.preview = evt.target.result;
            }, 0);
          };
          reader.readAsDataURL(blob);
        },
        error => {
          vm.loadingPreview = false;
          showArrayBufferError(error);
        },
      );
  };

  vm.getGenerateModel = function() {
    const model = angular.copy(vm.data);

    model.tags = (vm.templateTags || []).reduce((o, e) => {
      if (!!e.value) {
        o[e.tag] = e.value;
      }
      return o;
    }, {});

    if (vm.hasQrCodeTag) model.addQrCode = false;

    return model;
  };

  vm.retrieveTags = function() {
    vm.hasQrCodeTag = false;
    vm.loadingTags = true;
    const model = vm.getGenerateModel();
    delete model.tags;

    $http.post(`${appUrls.api}/Api/Relation/AMLSingleDocumentCustomTags/`, model).then(
      ({ data }) => {
        if (data) {
          vm.templateTags = data.reduce((result, tag) => {
            //Lower case and remove {}
            const key = tag.toLowerCase().replace(/[{}]/, '');
            if (key === 'document.qr') {
              vm.hasQrCodeTag = true;
              return result; //Ignore qr code tag
            }
            const oldTag = vm.templateTags.find(x => x.key === key);

            result.push({
              tag,
              key,
              info: translateListFilter(`{${key}}`, 'mailplaceholder', ''),
              value: (oldTag && oldTag.value) || '', //Copy old value into new object
            });
            return result;
          }, []);
        } else {
          vm.templateTags = [];
        }
        vm.loadingTags = false;
      },
      error => {
        showError(error);
        vm.loadingTags = false;
      },
    );
  };

  vm.canGenerate = function() {
    //At least one document should be selected
    if (vm.data.templateId) return true;

    // No documents will be generated
    return false;
  };

  vm.loadTemplates = function() {
    $http
      .get(`${appUrls.api}/Api/DocumentTemplate/Templates/`, {
        params: {
          templateTypes: [templateType],
          companyId: relation.companyId,
        },
      })
      .then(
        ({ data }) => {
          const relationType = relation.type;
          const templates = data
            .filter(x => x.relationType === null || x.relationType === relationType)
            .map(x => ({ ...x, label: `${x.name} (${x.languageCode})` }));
          const systemTemplate = {
            id: guid.empty,
            label: $filter('translate')('Use system template'),
          };

          vm.templates = [systemTemplate, ...templates];
          vm.data.templateId = (
            vm.templates.find(x => x.languageCode === relation.languageCode) || {
              id: guid.empty,
            }
          ).id;
          vm.retrieveTags();
        },
        error => {
          showError(error);
        },
      );
  };

  vm.loadTemplates();

  vm.cancel = function() {
    close(null, 500);
  };
}
